<template>
  <div class="card line-chart">
    <div class="card-header py-1 pr-0 pl-3">
      <fa-icon v-if="icon" :icon="icon" /> {{ header }} [{{ unit }}]
      <button type="button" class="close" data-dismiss="modal">
        <span class="px-3"><fa-icon icon="times" /></span>
      </button>
    </div>
    <div class="card-body">
      <canvas :id="canvasId"></canvas>
    </div>
  </div>  
</template>

<script>
import Chart from '@/lib/chart.js'
import { mapGetters } from 'vuex'

export default {
  name: 'lineChart',
  props: ['icon', 'header', 'id', 'min', 'max', 'ranges', 'data', 'unit'],
  data () {
    return {
      idSuffix: '-hist',
      chart: null,
      init: true,
      config: {
        type: 'line',
        data: {
          datasets: [
            {
              data: [],
              fill: false,
              lineTension: 0,
              borderColor: 'rgb(36, 64, 107)'
            }
          ]
        },
        options: {
          responsive: true,
          events: [],
          animation: false,
          elements: {
            point: {
              backgroundColor: 'rgb(36, 64, 107)'
            }
          },
          title: {
            display: false
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  unit: 'second',
                  displayFormats: {
                    second: 'HH:mm:ss'
                  }
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  // beginAtZero: true,
                  // stepSize: 0.5,
                  // min: 0,
                  // max: 2
                }
              }
            ]
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['colors']),
    canvasId () {
      return this.id + '-hist'
    }
  },
  watch: {
    data () {
      this.updateChart()
    }
  },
  methods: {
    getConfig () {
      let config = this.config
      config.data.yHighlightRange = this.ranges
      config.options.scales.yAxes[0].ticks = {
        min: this.min || 0,
        max: this.max || 100
      }

      return config
    },
    createChart () {
      const ctx = document.getElementById(this.canvasId).getContext('2d')
      this.chart = new Chart(ctx, this.getConfig())
    },
    updateChart () {
      this.chart.data.datasets[0].data = this.data
      this.chart.update()
    }
  },
  mounted () {
    this.createChart()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/charts/LineChart.vue